import { ref } from 'vue'
import { defineStore } from 'pinia'
import { UserApi } from '@/api/modules/user'
import { UserInfo, UserInfoPayload } from '@/api/modules/user/types'

export const useUserStore = defineStore('user', () => {
  const profile = ref<UserInfo>()
  const loading = ref<boolean>(false)

  const userInfo = async () => {
    loading.value = true
    try {
      const res = await UserApi.userProfileRequest()
      profile.value = res
    } finally {
      loading.value = false
    }
  }

  const updateUserInfo = async (data: UserInfoPayload) => {
    loading.value = true
    try {
      await UserApi.updateUserProfileRequest(data)

      profile.value = data
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    profile,

    userInfo,
    updateUserInfo,
  }
})
